import getIsInCheckedMode from 'mini-mail-list-store/lib/utils/getIsInCheckedMode';
import { getIsDarkTheme, getThemeId, getThemeMetadata } from 'mini-theme';
import { isInInboxFolder } from 'mini-mail-list-store/lib/selectors/isInInboxFolder';

export const shouldShowThemeHeroImage = () => {
    // In multi select mode, never show the secondary header
    if (getIsInCheckedMode()) {
        return false;
    }

    const themeId = getThemeId();
    const isDarkTheme = getIsDarkTheme();
    const { heroImage } = getThemeMetadata(themeId, isDarkTheme);
    const isInInbox = isInInboxFolder();

    return !!heroImage && isInInbox;
};
